module.exports = __webpack_public_path__ + "img/dhfesta_logo-1.338452bf.png";